export const theme = {
  primary: {
    // main: "#01869d",
    // light: "#eac1ff",
    main: "#0078d4",
    light: "#eaeaea",
  },
};
